import router from 'next/router';
import {openWindow} from '../../../common/openWindow.function';
import {ApiStatusCodeVo} from '../../../common/shared/api/nicolas/vo/enums/ApiStatusCodeVo.enum';
import {RedeemCodeType} from '../../../graphql/generated/types';
import {SelfCertRequestType} from '../../../selfCert/SelfCertRequestType.enum';

interface GoToUrlByRedeemCodeTypeProps {
  redeemCodeType: RedeemCodeType;
  seriesId: number;
  code: string;
  resultCode: ApiStatusCodeVo;
  isWebView: boolean;
  isAndroid: boolean;
  onSubmitRedeemCode: ({isConfirmed}: {isConfirmed: boolean}) => void;
}

export function goToUrlByRedeemCodeType({
  redeemCodeType,
  seriesId,
  code,
  resultCode,
  isWebView,
  onSubmitRedeemCode,
}: GoToUrlByRedeemCodeTypeProps) {
  if (redeemCodeType === RedeemCodeType.Credit) {
    if (isWebView) {
      const scheme = 'kakaopage://open/webview/cash_history';
      window.location.assign(scheme);
    } else {
      router.push('/history/cash');
    }
  } else if (
    redeemCodeType === RedeemCodeType.Ticket ||
    redeemCodeType === RedeemCodeType.TicketBuy ||
    redeemCodeType === RedeemCodeType.TicketRent
  ) {
    const scheme = `kakaopage://open/content?series_id=${seriesId}`;
    if (isWebView) {
      window.location.assign(scheme);
    } else {
      router.push(`/content/${seriesId}`);
    }
  } else if (resultCode === ApiStatusCodeVo.ExternalNotAuthorized) {
    const callbackUrl = `https://${window.location.host}/redeem?code=${code}`;
    const type = SelfCertRequestType.OverCharging;
    const pageProcessId = Math.floor(new Date().getTime() / 1000); // unix time
    const authPath = `/auth/id/verify/start?process_id=${pageProcessId}&success_url=${encodeURIComponent(
      callbackUrl
    )}&type=${type}&redirect_in_window=false`;
    if (isWebView) {
      router.push(authPath);
    } else {
      openWindow({
        url: `https://${window.location.host}${authPath}`,
        target: '연령인증',
        features: 'width=460,height=700',
      });
    }
  } else if (resultCode === ApiStatusCodeVo.PointAge) {
    onSubmitRedeemCode({isConfirmed: true});
  }
}
